import { css } from '@emotion/react';

export const globalStyles = css`
  @font-face {
    font-family: 'Poppins';
    font-weight: 400;
    src: local('Poppins'), url(/fonts/Poppins-Regular.ttf) format('truetype');
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 500;
    src: local('Poppins'), url(/fonts/Poppins-Medium.ttf) format('truetype');
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 600;
    src: local('Poppins'), url(/fonts/Poppins-SemiBold.ttf) format('truetype');
  }
  @font-face {
    font-family: 'Poppins';
    font-weight: 700;
    src: local('Poppins'), url(/fonts/Poppins-Bold.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Poppins';
    font-weight: 900;
    src: local('Poppins'), url(/fonts/Poppins-ExtraBold.ttf) format('truetype');
  }

  body {
    margin: 0;
    font-family: Poppins, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-y: hidden;
  }

  #root {
    width: 100%;
    height: 100vh;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  @media (prefers-reduced-motion: no-preference) {
    .App-logo {
      animation: App-logo-spin infinite 20s linear;
    }
  }

  .App-header {
    background-color: #282c34;
    min-height: calc(100vh - 36px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
